// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsconfig =  {
    "aws_appsync_graphqlEndpoint": "https://n22mkzis2rcuxbqqldzq7zhhtm.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-4u7pltrtvneblhzt6wzynune3q",
};

export default awsconfig;